import { render, staticRenderFns } from "./ConfigRegrasImpressaoNova.vue?vue&type=template&id=71e6db68&scoped=true"
import script from "./ConfigRegrasImpressaoNova.vue?vue&type=script&lang=js"
export * from "./ConfigRegrasImpressaoNova.vue?vue&type=script&lang=js"
import style0 from "./ConfigRegrasImpressaoNova.vue?vue&type=style&index=0&id=71e6db68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6db68",
  null
  
)

export default component.exports